<script>
    const ListMenu = 
            [
                {"name":"Experiences","links":"experience"},
                {"name":"Portfolio","links":"portfolio"},
                {"name":"About Me","links":"aboutme"},
                {"name":"Contact Me","links":"contact-me"}
            ]
            
    export default ListMenu;
</script>